import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {Chart} from 'chart.js';

@Component({
  selector: 'sm-stacked-bar-chart',
  templateUrl: './stacked-bar-chart.component.html',
  styleUrls: ['./stacked-bar-chart.component.scss']
})
export class StackedBarChartComponent implements OnInit {
  public chart: any;
  canvas: any;
  ctx: any;
  @Input() dataSource: {} = {}
  // @ViewChild('mychart') mychart:any;
  @ViewChild('mychart', {static: false}) mychart!: ElementRef;
  constructor() { }

  ngOnInit(): void {
    // this.createChart();
  }


ngAfterViewInit() {
setTimeout(() => {
  this.canvas = this.mychart.nativeElement;

this.ctx = this.canvas.getContext('2d');
console.log(this.dataSource);

new Chart(this.ctx, {
    type: 'bar',
    data: this.dataSource,
    options: {
      legend: {
        display: true,
        position: 'bottom'
    },
    scales: {
      xAxes: [{
        stacked: true
      }],
      yAxes: [{
        stacked: true        
      }]
    }
      // scales: {
      //     yAxes: [{
      //         ticks: {
      //             beginAtZero: true
      //         }
      //     }]
      // }
  }
});


}, 100);

}

}